import { promotionApiService } from '../services/promotionApi';

/**
 * Synchronise les codes promo du localStorage vers le backend
 * Utilisé quand l'utilisateur se connecte pour récupérer les codes gagnés hors ligne
 */
export const syncLocalPromoCodestoBackend = async (): Promise<void> => {
  try {
    const localCodes = localStorage.getItem('userPromoCodes');
    if (!localCodes) {
      console.log('📭 Aucun code promo local à synchroniser');
      return;
    }

    const codes = JSON.parse(localCodes);
    if (!Array.isArray(codes) || codes.length === 0) {
      console.log('📭 Aucun code promo valide à synchroniser');
      return;
    }

    console.log(`🔄 Synchronisation de ${codes.length} codes promo vers le backend...`);
    
    let syncedCount = 0;
    let errorCount = 0;

    for (const codeData of codes) {
      try {
        // Essayer de trouver la promotion par code
        const promotions = await promotionApiService.getPromotions();
        const promotion = promotions.find(p => p.code === codeData.code);
        
        if (promotion) {
          console.log(`🎯 Synchronisation du code ${codeData.code} (ID: ${promotion.id})`);
          
          try {
            await promotionApiService.saveUserPromoCode(promotion.id, codeData.source || 'wheel');
            console.log(`✅ Code ${codeData.code} synchronisé avec succès`);
            syncedCount++;
          } catch (saveError: any) {
            if (saveError.message?.includes('déjà ce code promo')) {
              console.log(`ℹ️ Code ${codeData.code} déjà présent dans le backend`);
              syncedCount++;
            } else {
              console.error(`❌ Erreur lors de la sauvegarde de ${codeData.code}:`, saveError);
              errorCount++;
            }
          }
        } else {
          console.warn(`⚠️ Promotion ${codeData.code} introuvable dans le backend`);
          errorCount++;
        }
      } catch (error) {
        console.error(`❌ Erreur lors de la synchronisation de ${codeData.code}:`, error);
        errorCount++;
      }
    }

    console.log(`📊 Synchronisation terminée: ${syncedCount} réussis, ${errorCount} erreurs`);
    
    // Si tous les codes ont été synchronisés avec succès, nettoyer le localStorage
    if (errorCount === 0) {
      localStorage.removeItem('userPromoCodes');
      console.log('🧹 localStorage nettoyé après synchronisation réussie');
    }

  } catch (error) {
    console.error('❌ Erreur générale lors de la synchronisation des codes promo:', error);
  }
};

/**
 * Vérifie et synchronise automatiquement les codes promo au login
 */
export const autoSyncPromoCodesOnLogin = async (): Promise<void> => {
  try {
    console.log('🔄 Vérification automatique des codes promo à synchroniser...');
    await syncLocalPromoCodestoBackend();
  } catch (error) {
    console.error('❌ Erreur lors de la synchronisation automatique:', error);
  }
};
